import { z } from "zod";
import { CATEGORY, NAME, PRIORITY, TERM } from "../consts";

export const schema = z.object({
  [NAME]: z.string().optional(),
  [CATEGORY]: z.string().optional(),
  [PRIORITY]: z.string().optional(),
  [TERM]: z.string().optional(),
});

export type formValues = z.infer<typeof schema>;
